import { Routes, Route } from 'react-router-dom';
import Login from '../pages/Login/login';
// import Dashboard from '../pages/Dashboard/Dashboard';
import CryptoTest from '../pages/CryptoTest/CryptoTest';
import PageNotFound from '../pages/PageNotFound/PageNotFound';
import ApplicationSummary from '../pages/Counselling/ApplicationSummary';
import LiveUpdates from '../pages/Counselling/LiveUpdates';
import CounsellingStatus from '../pages/Counselling/CounsellingStatus';
import TrackChanges from '../pages/Counselling/TrackChanges';
import TransferFilter from '../pages/Counselling/TransferFilter';
import ChangeSchoolInfo from '../pages/Counselling/ChangeSchoolInfo';
import ChangeVacancy from '../pages/Counselling/ChangeVacancy';
import FrontPage from '../pages/Counselling/FrontPage';
import DEE from '../pages/Counselling/conduct-counselling/DEE';
import OrderCopyPdf from '../pages/Counselling/Print/OrderCopyPdf';
import OrderCopyDetails from '../pages/Counselling/order-copy-details/OrderCopyDetails';
import InterDistrict from '../pages/Counselling/inter-district/InterDistrict';
import VacancyUpdate from '../pages/Counselling/vacancy-update/VacancyUpdate';
import CounsellingDashboard from '../pages/Counselling/counselling-dashboard/CounsellingDashboard';
import PlanNewCounselling from '../pages/Counselling/plan-new-counselling/PlanNewCounselling';
import SeniorityUploadType from '../pages/Counselling/update-seniority/seniority-front-page/seniorityFrontPage';
import SeniorityOrder from '../pages/Counselling/update-seniority/seniority-order/SeniorityOrder';
import SeniorityExcelUpload from '../pages/Counselling/update-seniority/seniority-excel-upload/SeniorityExcelUpload';
import AppLayout from '../layouts/Applayout';

// ── Centralized route config ─────────────────────────────────────────────────
// Single source of truth for paths and breadcrumb labels.
// Add new routes here — Breadcrumb.tsx reads from this automatically.

export interface RouteConfig {
  path: string;
  label: string;
  element: React.ReactNode;
}

export const APP_ROUTES: RouteConfig[] = [
  // { path: '/dashboard', label: 'Dashboard', element: <Dashboard /> },
  {
    path: '/counselling/dashboard',
    label: 'Dashboard',
    element: <CounsellingDashboard />,
  },
  {
    path: '/counselling/front-page',
    label: 'Counselling',
    element: <FrontPage />,
  },
  {
    path: '/counselling/plan-new-counselling',
    label: 'Plan New Counselling',
    element: <PlanNewCounselling />,
  },
  {
    path: '/counselling/dee',
    label: 'Counselling',
    element: <DEE />,
  },
  {
    path: '/counselling/order-copy-details',
    label: 'Update Order Copy Details',
    element: <OrderCopyDetails />,
  },
  {
    path: '/counselling/inter-district',
    label: 'Inter District Transfer',
    element: <InterDistrict />,
  },
  {
    path: '/counselling/vacancy-update',
    label: 'Update Vacancies',
    element: <VacancyUpdate />,
  },
  {
    path: '/counselling/vacancy-update-aided-sch',
    label: 'Aided School Update Vacancies',
    element: <VacancyUpdate />,
  },
  { path: '/crypto-test', label: 'Crypto Test', element: <CryptoTest /> },
  {
    path: '/counselling/application-summary',
    label: 'Application Summary',
    element: <ApplicationSummary />,
  },
  {
    path: '/counselling/live-updates',
    label: 'Live Updates',
    element: <LiveUpdates />,
  },
  {
    path: '/counselling/status',
    label: 'Counselling Summary',
    element: <CounsellingStatus />,
  },
  {
    path: '/counselling/track-changes',
    label: 'Transfers in a School',
    element: <TrackChanges />,
  },
  {
    path: '/counselling/staff-Transferfilter',
    label: 'Teacher Transfer',
    element: <TransferFilter />,
  },
  {
    path: '/counselling/school-info',
    label: 'Change School Information',
    element: <ChangeSchoolInfo />,
  },
  {
    path: '/counselling/change-vacancy',
    label: 'Change Vacancy',
    element: <ChangeVacancy />,
  },
  {
    path: '/counselling/seniority',
    label: 'Seniority Update',
    element: <DEE />,
  },
  {
    path: '/counselling/seniority-type',
    label: 'Update Seniority',
    element: <SeniorityUploadType />,
  },
  {
    path: '/counselling/seniority-order',
    label: 'Seniority Order',
    element: <SeniorityOrder />,
  },
  {
    path: '/counselling/seniority-excel-upload',
    label: 'Excel Uploaded Seniority',
    element: <SeniorityExcelUpload />,
  },
];

/**
 * Builds a lookup map from the last path segment to its label.
 * e.g. '/counselling/live-updates' → { 'live-updates': 'Live Updates' }
 * Breadcrumb.tsx uses this to resolve labels without a separate map.
 */
export const ROUTE_LABEL_MAP: Record<string, string> = APP_ROUTES.reduce(
  (map, route) => {
    const lastSegment = route.path.split('/').filter(Boolean).pop();
    if (lastSegment) {
      map[lastSegment] = route.label;
    }
    return map;
  },
  {} as Record<string, string>
);

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      {/* Standalone print page (no app-shell chrome, so it prints clean) */}
      <Route path="/auth/order-copy-pdf" element={<OrderCopyPdf />} />

      <Route element={<AppLayout />}>
        {APP_ROUTES.map((route) => (
          <Route key={route.path} path={route.path} element={route.element} />
        ))}
      </Route>

      {/* Catch-all: any unmatched route shows 404 */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}
